import React from "react";
import GradientCard from "../../Components/Card/GradientCard";
import BenefitBox from "../../Components/Benefitbox/Benefitbox";
import "./Homepage.css";
import WorkBox from "../../Components/WorkBox/WorkBox";
import PricingSection from "../../Components/PricingSection/PricingSection";
import TestimonialsCarousel from "../../Components/Testimonials/Testimonial";
import FAQSection from "../../Components/FAQ-Section/FAQ";
import ContactSection from "../../Components/CTAsection/CTAsection";
import Footer from "../../Components/Footer/Footer";


const benefits = [
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION.",
  },
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION.",
  },
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION.",
  },
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION",
  },
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION.",
  },
  {
    icon: "/assets/Icon.png" /*ADD SUITABLE ICONS IN ASSETS FOLDER */,
    title: "TITLE",
    description: "DESCRIPTION.",
  },
];

const HomePage = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="text-and-card" id= "home">
        <div className="text-content">
          <div className="active-users">
            <div className="avatars">
              <img src="/assets/avtar1.png" alt="User 1" />
              <img src="/assets/avtar2.png" alt="User 2" />
              <img src="/assets/avtar3.png" alt="User 3" />
            </div>
            <span>1230+ active users</span>
          </div>

          <h1 className="Tit">Title</h1>
          <p className="Desc">Some supporting text for your SaaS product.</p>

          <div className="card-buttons">
            <button className="btn-primary">Primary CTA</button>
            <button className="btn-secondary">Secondary CTA</button>
          </div>
        </div>
        <GradientCard image="/assets/SaaS-Preview.jpg" />
      </div>

      {/* Trusted By Section */}
      <div className="trusted-by-section">
        <h2 className="trusted-heading underline">Trusted by</h2>
        <div className="logo-marquee">
          <div className="logo-track">
            {Array(2)
              .fill(null)
              .map((_, idx) => (
                <React.Fragment key={idx}>
                  <img src="/assets/Logo1.png" alt="Logo" />
                  <img src="/assets/Logo2.png" alt="Logo" />
                  <img src="/assets/Logo3.png" alt="Logo" />
                  <img src="/assets/Logo4.png" alt="Logo" />
                  <img src="/assets/Logo5.png" alt="Logo" />
                  <img src="/assets/Logo6.png" alt="Logo" />
                  <img src="/assets/Logo7.png" alt="Logo" />
                  <img src="/assets/Logo8.png" alt="Logo" />
                  <img src="/assets/Logo9.png" alt="Logo" />
                  <img src="/assets/Logo10.png" alt="Logo" />
                  <img src="/assets/Logo11.png" alt="Logo" />
                  <img src="/assets/Logo12.png" alt="Logo" />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section" id="Services">
        <h2 className="benefits-title">Benefits/Services</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <BenefitBox
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </div>
      <div className="how-it-works-section" id="How-it-works">
        <h2 className="how-title">How "Your Product Name" Works</h2>
        <p className="Desc">Some supporting text.</p>
        <div className="how-grid">
          <WorkBox
            icon="/assets/step1.png" /*ADD SUITABLE IMAGE PATH HERE */
            title="Step 1"
            description="Sign up and create your profile to get started."
          />
          <WorkBox
            icon="/assets/step2.png"
            title="Step 2"
            description="Choose a plan and explore your dashboard."
          />
          <WorkBox
            icon="/assets/step3.jpg"
            title="Step 3"
            description="Track results and optimize your workflow."
          />
        </div>
      </div>
      <div id="Pricing"><PricingSection /></div>
      <div><TestimonialsCarousel/></div>
      <div id="FAQs"><FAQSection/></div>
      <div><ContactSection/></div>
      <div><Footer/></div>
    </div>
  );
};

export default HomePage;
